import React from 'react';
import classNames from 'classnames';

import './product-box-name.scss';

interface ProductBoxNameProps {
    dealerName?: string;
    productHasNoOffers: boolean;
    className?: string;
}

const ProductBoxName: React.FC<ProductBoxNameProps> = ({ dealerName, className, productHasNoOffers }) => {
    if (productHasNoOffers || !dealerName) {
        return null;
    }

    return (
        <span className={classNames('producer-name', className)}>
            {` w ${dealerName}`}
        </span>
    );
};

export default ProductBoxName;
